import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AdminSideMenu from '../../components/admin/AdminSideMenu';
import '../../styles/admin/AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const handleCompanyList = () => {
    navigate('/admin/company-list');
  };

  const handleLogout = () => {
    // Remove tokens and user info from storage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userInfo');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    
    // Redirect to login page
    navigate('/login');
  };

  return (
    <div className="adminDashboardContainer">
      <div className="adminHeader">
        <h1 className="adminTitle" onClick={handleCompanyList}>TAPGO</h1>
        <button className="admin-logout-button" onClick={handleLogout}>로그아웃</button>
      </div>
      
      <div className="adminContent">
        <AdminSideMenu />
        <div className="adminMainContent">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 